import axios, { AxiosRequestConfig } from "axios";

import { API_BASE_URL, WEB_REPORT_TOKEN } from "../config";

export const client = axios.create({
  baseURL: API_BASE_URL,
});

/**
 * Constructs headers for authenticated requests.
 * Prioritizes passed token, falls back to localStorage.
 */
export const authConfig = (
  token?: string | null,
  extraHeaders: Record<string, string> = {},
): AxiosRequestConfig => {
  const t = token || localStorage.getItem("auth_token");
  const headers = { ...extraHeaders };
  if (t) {
    headers["Authorization"] = `Bearer ${t}`;
  }
  return { headers };
};

/**
 * Constructs headers for requests requiring the web report token.
 */
export const webConfig = (
  extraHeaders: Record<string, string> = {},
): AxiosRequestConfig => ({
  headers: {
    "X-Web-Token": WEB_REPORT_TOKEN as string,
    ...extraHeaders,
  },
});
